import { Modal, Spin, Checkbox, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { get } from '../../config/dataService/dataService';

const Checklist = ({ open, onContinue, buttonLabel, onClose, checklistId }) => {
  const [items, setItems] = useState([]);
  const [checked, setChecked] = useState({});
  const [loading, setLoading] = useState(false);

  const [term1, setTerm1] = useState(false);
  const [term2, setTerm2] = useState(false);

  useEffect(() => {
    if (open && checklistId) {
      setLoading(true);
      get(`workflow/GetProofchecklistoptionById?checklistId=${checklistId}`)
        .then(res => {
          const options = (res?.data || []).map(opt => ({
            id: opt.optionId,
            name: opt.checklistitem,
          }));
          setItems(options);
          const initialChecked = {};
          options.forEach(opt => { initialChecked[opt.id] = false; });
          setChecked(initialChecked);
        })
        .finally(() => setLoading(false));
    } else if (!open) {
      setItems([]);
      setChecked({});
      setTerm1(false);
      setTerm2(false);
    }
  }, [open, checklistId]);

  const allChecked = items.length > 0 && items.every(opt => checked[opt.id]);
  const allTermsChecked = term1 && term2;

  const handleCheck = (id, value) => {
    setChecked(prev => ({ ...prev, [id]: value }));
  };

  const handleContinue = () => {
    if ((checklistId && allChecked) || (!checklistId && allTermsChecked)) {
      onContinue && onContinue();
    }
  };

  return (
    <Modal
      open={open}
      title="Please accept the terms"
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      keyboard={false}
      centered
    >
      <Spin spinning={loading}>
        <div>
          {checklistId ? (
            items.map(opt => (
              <div className="checklist-item" key={opt.id}>
                <Checkbox
                  checked={checked[opt.id]}
                  onChange={e => handleCheck(opt.id, e.target.checked)}
                >
                  {opt.name}
                </Checkbox>
              </div>
            ))
          ) : (
            <>
              <div className="checklist-item">
                <Checkbox
                  checked={term1}
                  onChange={() => setTerm1(!term1)}
                >
                  I agree to the Terms and Conditions.
                </Checkbox>
              </div>
              <div className="checklist-item">
                <Checkbox
                  checked={term2}
                  onChange={() => setTerm2(!term2)}
                >
                  I have read and understood the Privacy Policy.
                </Checkbox>
              </div>
            </>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
            <Button
              type="primary"
              className="btn-add_new"
              disabled={!(checklistId ? allChecked : allTermsChecked)}
              onClick={handleContinue}
            >
              {buttonLabel}
            </Button>
          </div>
         </div> 
      </Spin>
    </Modal>
  );
};

export default Checklist;
